import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import './especialidades.css';

// trocar cores, provavelmente textos, adicionar uns textinhos aí no meio e pelo visto uma ondinha lol

import { Especialidade, Carrossel } from '../../components';

import { EspecIcone1, EspecIcone2, EspecIcone3, EspecIcone4, EspecIcone5, EspecIcone6, EspecIcone7, EspecIcone8, EspecIcone9, EspecIcone10, EspecIcone11, EspecIcone12 } from './especialidades-icones';

import { tituloEspec1, tituloEspec2, tituloEspec3, tituloEspec4, tituloEspec5, tituloEspec6, tituloEspec7, tituloEspec8, tituloEspec9, tituloEspec10, tituloEspec11, tituloEspec12 } from './especialidades-titulos';

import { textoEspec1, textoEspec2, textoEspec3, textoEspec4, textoEspec5, textoEspec6, textoEspec7, textoEspec8, textoEspec9, textoEspec10, textoEspec11, textoEspec12 } from './especialidades-textos';

const animationDelay = 0.35;

const offset = 500;

function calculoDelay() {

  const step = 300;
  const arrayLength = 6;
  let accumulatedSum = 0;

  const resultArray = Array.from({ length: arrayLength }, () => {
    accumulatedSum += step;
    return accumulatedSum;
  });

  return resultArray;
}

const Especialidades = () => {

  const listaEspecialidades1 = [
    { id: 1, titulo: tituloEspec1, imagemSrc: EspecIcone1, texto: textoEspec1 },
    { id: 2, titulo: tituloEspec2, imagemSrc: EspecIcone2, texto: textoEspec2 },
    { id: 3, titulo: tituloEspec3, imagemSrc: EspecIcone3, texto: textoEspec3 },
    { id: 4, titulo: tituloEspec4, imagemSrc: EspecIcone4, texto: textoEspec4 },
    { id: 5, titulo: tituloEspec5, imagemSrc: EspecIcone5, texto: textoEspec5 },
    { id: 6, titulo: tituloEspec6, imagemSrc: EspecIcone6, texto: textoEspec6 },
  ];

  const listaEspecialidades2 = [
    { id: 7, titulo: tituloEspec7, imagemSrc: EspecIcone7, texto: textoEspec7 },
    { id: 8, titulo: tituloEspec8, imagemSrc: EspecIcone8, texto: textoEspec8 },
    { id: 9, titulo: tituloEspec9, imagemSrc: EspecIcone9, texto: textoEspec9 },
    { id: 10, titulo: tituloEspec10, imagemSrc: EspecIcone10, texto: textoEspec10 },
    { id: 11, titulo: tituloEspec11, imagemSrc: EspecIcone11, texto: textoEspec11 },
    { id: 12, titulo: tituloEspec12, imagemSrc: EspecIcone12, texto: textoEspec12 },
  ];

  const delay = calculoDelay();

  return (
    <div className="psico__especialidades section__padding" id="especialidade">
      <div className="psico__especialidades-title">
        {/* será que dá pra melhorar esse efeito do typed-text? alguma biblioteca? */}
        <AnimationOnScroll animateIn="slide-in-left" duration={1.5}>
          <h2>Tratamentos e Especialidades</h2>
        </AnimationOnScroll>
      </div>

      <div className="psico__especialidades-title__broken">
        <AnimationOnScroll animateIn="slide-in-left" duration={1}>
          <h2>Tratamentos e</h2>
        </AnimationOnScroll>
        <AnimationOnScroll animateIn="slide-in-left" duration={1} delay={400}>
          <h2>Especialidades</h2>
        </AnimationOnScroll>
      </div>

      <div className="psico__especialidades-descricao">
        <AnimationOnScroll animateIn="slide-in-left" duration={1.5}>

          <p>Estou aqui para oferecer <strong>o melhor tratamento para você</strong> ter a saúde mental que merece!</p>

        </AnimationOnScroll>
      </div>

      <div className="psico__especialidades-cards">
        <div className="psico__especialidades-cards__subtitle">
          <AnimationOnScroll animateIn="slide-in-left" duration={1.5}>
            <h4>Por que você busca terapia hoje?</h4>
          </AnimationOnScroll>
        </div>

        <div className="psico__especialidades-cards__row1">
          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[0]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec1} imagemSrc={EspecIcone1} texto={textoEspec1} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[1]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec2} imagemSrc={EspecIcone2} texto={textoEspec2} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[2]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec3} imagemSrc={EspecIcone3} texto={textoEspec3} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[3]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec4} imagemSrc={EspecIcone4} texto={textoEspec4} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[4]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec5} imagemSrc={EspecIcone5} texto={textoEspec5} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[5]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec6} imagemSrc={EspecIcone6} texto={textoEspec6} />
          </AnimationOnScroll>

        </div>

        <div className="psico__especialidades-cards__rowCom3-1">
          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[0]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec1} imagemSrc={EspecIcone1} texto={textoEspec1} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[1]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec2} imagemSrc={EspecIcone2} texto={textoEspec2} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[2]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec3} imagemSrc={EspecIcone3} texto={textoEspec3} />
          </AnimationOnScroll>
        </div>

        <div className="psico__especialidades-cards__rowCom3-2">
          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[2]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec6} imagemSrc={EspecIcone6} texto={textoEspec6} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[1]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec5} imagemSrc={EspecIcone5} texto={textoEspec5} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[0]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec4} imagemSrc={EspecIcone4} texto={textoEspec4} />
          </AnimationOnScroll>
        </div>

        <div className="psico__especialidades-cards__rowCom2-1">
          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[0]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec1} imagemSrc={EspecIcone1} texto={textoEspec1} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[1]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec2} imagemSrc={EspecIcone2} texto={textoEspec2} />
          </AnimationOnScroll>
        </div>

        <div className="psico__especialidades-cards__rowCom2-2">
          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[1]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec3} imagemSrc={EspecIcone3} texto={textoEspec3} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[0]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec4} imagemSrc={EspecIcone4} texto={textoEspec4} />
          </AnimationOnScroll>
        </div>

        <div className="psico__especialidades-cards__rowCom2-3">
          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[0]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec5} imagemSrc={EspecIcone5} texto={textoEspec5} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[1]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec6} imagemSrc={EspecIcone6} texto={textoEspec6} />
          </AnimationOnScroll>
        </div>

        <div className="psico__especialidades-cards__subtitle">
          <AnimationOnScroll animateIn="slide-in-right" duration={1.5}>
            <h4>Como vou te ajudar! </h4>
          </AnimationOnScroll>
        </div>

        <div className="psico__especialidades-cards__row2">

          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[5]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec12} imagemSrc={EspecIcone12} texto={textoEspec12} />
          </AnimationOnScroll>


          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[4]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec11} imagemSrc={EspecIcone11} texto={textoEspec11} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[3]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec10} imagemSrc={EspecIcone10} texto={textoEspec10} />
          </AnimationOnScroll>


          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[2]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec9} imagemSrc={EspecIcone9} texto={textoEspec9} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[1]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec8} imagemSrc={EspecIcone8} texto={textoEspec8} />
          </AnimationOnScroll>


          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[0]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec7} imagemSrc={EspecIcone7} texto={textoEspec7} />
          </AnimationOnScroll>

        </div>

        <div className="psico__especialidades-cards__rowCom3-3">
          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[0]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec12} imagemSrc={EspecIcone12} texto={textoEspec12} />
          </AnimationOnScroll>


          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[1]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec11} imagemSrc={EspecIcone11} texto={textoEspec11} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[2]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec10} imagemSrc={EspecIcone10} texto={textoEspec10} />
          </AnimationOnScroll>
        </div>

        <div className="psico__especialidades-cards__rowCom3-4">
          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[2]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec9} imagemSrc={EspecIcone9} texto={textoEspec9} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[1]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec8} imagemSrc={EspecIcone8} texto={textoEspec8} />
          </AnimationOnScroll>


          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[0]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec7} imagemSrc={EspecIcone7} texto={textoEspec7} />
          </AnimationOnScroll>
        </div>

        <div className="psico__especialidades-cards__rowCom2-6">
          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[1]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec8} imagemSrc={EspecIcone8} texto={textoEspec8} />
          </AnimationOnScroll>


          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[0]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec7} imagemSrc={EspecIcone7} texto={textoEspec7} />
          </AnimationOnScroll>
        </div>

        <div className="psico__especialidades-cards__rowCom2-5">
          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[0]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec10} imagemSrc={EspecIcone10} texto={textoEspec10} />
          </AnimationOnScroll>


          <AnimationOnScroll animateIn="slide-in-left-row" delay={delay[1]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec9} imagemSrc={EspecIcone9} texto={textoEspec9} />
          </AnimationOnScroll>
        </div>

        <div className="psico__especialidades-cards__rowCom2-4">
          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[1]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec12} imagemSrc={EspecIcone12} texto={textoEspec12} />
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="slide-in-right-row" delay={delay[0]} duration={animationDelay} offset={offset}>
            <Especialidade titulo={tituloEspec11} imagemSrc={EspecIcone11} texto={textoEspec11} />
          </AnimationOnScroll>
        </div>

      </div>

      <div className="psico__especialidades-carrossel">
        <div className="psico__especialidades-carrossel__row1">
          <AnimationOnScroll animateIn="slide-in-left" duration={1.5}>
            <h4>Por que você busca terapia hoje?</h4>
            <div className="psico__especialidades-carrossel__row1-cards">
              <Carrossel especialidades={listaEspecialidades1} />
            </div>
          </AnimationOnScroll>
        </div>
        <div className="psico__especialidades-carrossel__row2">
          <AnimationOnScroll animateIn="slide-in-right" duration={1.5}>
            <h4>Como vou te ajudar! </h4>
            <div className="psico__especialidades-carrossel__row2-cards">
              <Carrossel especialidades={listaEspecialidades2} />
            </div>
          </AnimationOnScroll>
        </div>
      </div>

    </div>
  )
}

export default Especialidades
